class User{
    id: string;
    username: string;
    name: string;
    email: string;
    phone: string;
    roles: string[];
    token?: string;

    constructor(id: string, username: string, name: string, email: string, phone: string, roles: string[], token?: string) {
        this.id = id;
        this.username = username;
        this.name = name;
        this.email = email;
        this.phone = phone;
        this.roles = roles;
        this.token = token;
    }

    hasRole(role: string) {
        return this.roles.includes(role);
    }

    isValidToken(token: string) {
    }

    saveLocalStorage() {
        localStorage.setItem('sai-user', JSON.stringify(this));
    }

    static loadLocalStorage() {
        const data = localStorage.getItem('sai-user');
        if (data) {
            return JSON.parse(data);
        }
        return null;
    }

    static clearLocalStorage() {
        localStorage.removeItem('sai-user');
    }


}

export { User };